/**
 * PTT相关类型定义
 */

// 后端返回的错误类型
export interface PttError {
  code: string;           // 后端返回的错误码
  message: string;        // 后端返回的错误信息
  details?: any;          // 详细错误信息
  timestamp: number;      // 错误发生时间
}

// 前端错误处理结果
export interface PttErrorResult {
  success: false;
  error: PttError;
}

// PTT命令类型
export interface PttCommand {
  deviceId: string;
  command: 'start_session' | 'stop_session' | 'get_status' | 'ping';
  timestamp: number;
}

// PTT响应类型
export interface PttResponse {
  success: boolean;
  message: string;
  data?: any;
  error?: PttError;
}

// 前端错误分类
export enum PttErrorType {
  NETWORK_ERROR = 'NETWORK_ERROR',           // 网络连接错误
  DEVICE_NOT_FOUND = 'DEVICE_NOT_FOUND',     // 设备未找到
  DEVICE_OFFLINE = 'DEVICE_OFFLINE',         // 设备离线
  PERMISSION_DENIED = 'PERMISSION_DENIED',   // 权限不足
  INVALID_COMMAND = 'INVALID_COMMAND',       // 无效命令
  INVALID_DEVICE_ID = 'INVALID_DEVICE_ID',   // 无效设备ID
  STATE_INCONSISTENCY = 'STATE_INCONSISTENCY', // 状态不一致
  INITIALIZATION_ERROR = 'INITIALIZATION_ERROR', // 初始化错误
  TIMEOUT = 'TIMEOUT',                       // 超时错误
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'            // 未知错误
}

// 用户友好的错误信息映射
export const PTT_ERROR_MESSAGES: Record<string, string> = {
  [PttErrorType.NETWORK_ERROR]: '网络连接失败，请检查网络设置',
  [PttErrorType.DEVICE_NOT_FOUND]: '设备未找到，请检查设备连接',
  [PttErrorType.DEVICE_OFFLINE]: '设备已离线，请重新连接设备',
  [PttErrorType.PERMISSION_DENIED]: '权限不足，请检查用户权限',
  [PttErrorType.INVALID_COMMAND]: '无效的命令，请重试',
  [PttErrorType.INVALID_DEVICE_ID]: '无效的设备ID',
  [PttErrorType.STATE_INCONSISTENCY]: '状态不一致，请重新同步',
  [PttErrorType.INITIALIZATION_ERROR]: '服务初始化失败',
  [PttErrorType.TIMEOUT]: '操作超时，请检查网络连接',
  [PttErrorType.UNKNOWN_ERROR]: '发生未知错误，请重试'
};
